import React from 'react'
import { MenuItemType } from '@utils/types'
import { WImage, Button } from '@components/atoms'
import styles from './AttivitaCard.module.sass'
import { handleBrandLinkTracking } from '@utils/tracking'
import { useRouter } from 'next/router'
import { PaginaNode } from '@gql/graphql'

interface Props {
  item: MenuItemType
  selected: string
  editMode?: boolean
  className?: string
  pagina?: PaginaNode
}

const AttivitaCard = (props: Props) => {
  const { item = undefined, selected, editMode = false, className = '', pagina } = props
  const router = useRouter()

  const handleClick = () => {
    handleBrandLinkTracking(item?.ctaLabel, router.asPath)
  }

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WImage
        src={item.image}
        maxWidth={340}
        maxHeight={460}
        objectFit="cover"
        alt={item.alt}
        title={item.alt}
      />
      {!!item.ctaLabel && !!item.url && (
        <Button
          label={item.ctaLabel}
          href={item.url}
          newPage={item.blank}
          color="white"
          className={styles.cta}
          onClick={handleClick}
          variant={item.ctaVariant || 'primary'}
        />
      )}
    </div>
  ) : (
    <></>
  )
}

export default AttivitaCard
